import Repository from "@/repositories/api.js"

export default {
  /**
   * Initiates 2FA setup - generates OTP secret and provisioning URI
   * @returns {Promise<{provisioning_uri: string, secret: string}>}
   */
  async setup() {
    let response = await Repository.post("two_factor/setup")
    return response.data
  },

  /**
   * Verifies OTP and enables 2FA
   * @param {string} otpAttempt - The 6-digit OTP code
   * @returns {Promise<{backup_codes: string[]}>}
   */
  async enable(otpAttempt) {
    let response = await Repository.post("two_factor/enable", {
      otp_attempt: otpAttempt
    })
    return response.data
  },

  /**
   * Disables 2FA for the current user
   * @param {string} password - User's password for confirmation
   * @returns {Promise<{disabled: boolean}>}
   */
  async disable(password) {
    let response = await Repository.delete("two_factor/disable", {
      data: { password: password }
    })
    return response.data
  },

  /**
   * Verifies OTP during login flow
   * @param {string} twoFactorToken - The JWT token from login response
   * @param {string} otpAttempt - The 6-digit OTP code or backup code
   * @param {boolean} rememberDevice - Whether to trust this device
   * @param {string} deviceFingerprint - Optional device identifier
   * @param {string} deviceName - Optional device name
   * @returns {Promise<Object>} - User data with access token
   */
  async verify(
    twoFactorToken,
    otpAttempt,
    rememberDevice = false,
    deviceFingerprint = null,
    deviceName = null
  ) {
    let response = await Repository.post("two_factor/verify", {
      two_factor_token: twoFactorToken,
      otp_attempt: otpAttempt,
      remember_device: rememberDevice,
      device_fingerprint: deviceFingerprint,
      device_name: deviceName
    })
    return response.data
  },

  /**
   * Regenerates backup codes (requires password)
   * @param {string} password - User's password for confirmation
   * @returns {Promise<{backup_codes: string[]}>}
   */
  async regenerateBackupCodes(password) {
    let response = await Repository.post("two_factor/backup_codes", {
      password: password
    })
    return response.data
  }
}
